<template>
    <div class="deleteModule" :class="isShowBtn?'':'noDeleteBtn'">
        <div class="titleBox">
            <div>{{titleTxt}}</div>
        </div>
        <div>
            <el-table
                    ref="dataTable"
                    :data="selectList"
                    highlight-current-row
                    size="mini"
                    max-height="175px"
                    border
            >
                <el-table-column prop="subCategoryName" label="细目名称"></el-table-column>
                <el-table-column prop="subCategoryNo" label="细目号"></el-table-column>
<!--                <el-table-column prop="type" label="细目编码"></el-table-column>-->
                <el-table-column prop="unit" label="单位"></el-table-column>
                <el-table-column prop="unitPrice" label="单价"></el-table-column>
                <el-table-column prop="unitCount" label="数量"></el-table-column>
                <el-table-column prop="unitPriceTypeShow"
                                 label="是否正式单价"
                                 v-if="index == 1 || index == 2">
                    <template slot-scope="scope">
                        <el-checkbox :checked="scope.row.unitPriceType == 'OFFICIAL'" >正式单价</el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column prop="taxRate"
                                 label="税率"
                                 v-if="index == 1 || index == 2">
                </el-table-column>
                <el-table-column prop="bidPrice"
                                 label="中标裸税单价"
                                 v-if="index == 1 || index == 2">
                </el-table-column>
                <el-table-column prop="unitSumPrice" label="合价"></el-table-column>
                <el-table-column prop="bidSumPrice"
                                 label="中标裸税合价"
                                 v-if="index == 1 || index == 2||index == 3">
                </el-table-column>
                <el-table-column prop="subContractSerialNumber"
                                 label="分项合同编号"
                                 v-if="index == 2">
                </el-table-column>
                <el-table-column label="操作" v-if="isShowBtn">
                    <template slot-scope="scope">
                        <el-button @click="handleDeleteClick(scope.row)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作" v-if="isShowModifyBtn">
                    <template slot-scope="scope">
                        <el-button @click="handleModifyClick(scope.row)" type="text" size="small">修改分包合同编号</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog
                title="修改分包合同编号"
                :visible.sync="isShowModifyDialog"
                width="30%"
                :before-close="handleClose">
            <el-form ref="form" :model="form" label-width="120px">
                <el-form-item label="分包合同编号">
                    <el-input v-model="form.subContractSerialNumber"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button type="info" @click="isShowModifyDialog = false">取 消</el-button>
                <el-button type="primary" @click="modifyEnum">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        deleteFrontItemsService,
        deleteMiddleItemsService,
        updateActItemSubContractId,
    } from '../../services/engineering'
    import {deleteItemsService} from '../../services/feeServices'
    export default {
        name: "delete-module",
        data(){
            return{
                dataForm:{
                    pageIndex: '',
                    pageSize: '',
                },
                total:'',
                selectList: [],

                selectItem: null,
                isShowModifyDialog: false,
                form: {
                    subContractSerialNumber: "",
                }
            }
        },
        props:{
            list:{
                type: Array,
                default: ()=>[],
            },
            titleTxt:{
                type: String,
                default: '',
            },
            isShowBtn: {
                type: Boolean,
                default: false,
            },
            isShowModifyBtn: {
                type: Boolean,
                default: false,
            },
            index:{
                type: Number,
                default: 0,
            },
        },
        watch: {
            list(value,oldvalue){
                setTimeout(()=> {
                    value.map(item => {
                        if (item.type == "MATERIAL"){
                            item.subCategoryName = item.productName
                            item.subCategoryNo = item.productNumber
                        }
                    })
                    this.selectList = this.list
                    this.$forceUpdate();
                },500)
            },
        },
        mounted() {
            this.setData();
        },
        methods:{
            onActive(menuCode) {

            },
            setData(){
                setTimeout(()=> {
                    this.list.map(item => {
                        if (item.type == "MATERIAL"){
                            item.subCategoryName = item.productName
                            item.subCategoryNo = item.productNumber
                        }
                    })
                    this.selectList = this.list
                    this.$forceUpdate();
                },500)
            },
            handleDeleteClick(row){
                this.$confirm("确定要删除吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    if(this.index == 1 || this.index == 2){
                        this.deleteMiddleItems(row)
                    }else if(this.index == 3){
                        this.deleteOtherItems(row)
                    }else{
                        this.deleteFrontItems(row)
                    }

                });

            },
            handleModifyClick(row) {
                this.selectItem = row;
                this.isShowModifyDialog = true;
            },
            modifyEnum() {
                let params = {
                    id: this.selectItem.id,
                    subContractSerialNumber: this.form.subContractSerialNumber,
                    subContractTypeEnum: this.selectItem.type,
                }
                updateActItemSubContractId(params).then( res => {
                    if (res.code == 10000000) {
                        this.isShowModifyDialog = false;
                        this.$emit('refreshData')
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
            //事中
            deleteMiddleItems(row){
                let params = {
                    id: row.id,
                    type: row.type,
                    isAct: this.index== 1 ? false: true
                }
                deleteMiddleItemsService(params).then( res => {
                    if(res.code == 10000000){
                        this.$emit('refreshDataList')
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //事前
            deleteFrontItems(row){
                let params = {
                    id: row.id,
                    type: row.type
                }
                deleteFrontItemsService(params).then( res => {
                    if(res.code == 10000000){
                        this.$emit('refreshDataList')
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //其它直接费
            deleteOtherItems(row){
                let params = {
                    id: row.id,
                    // type: row.type
                }
                deleteItemsService(params).then( res => {
                    if(res.code == 10000000){
                        this.$emit('refreshDataList')
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            // 分页改变事件
            handleCurrentChange(page) {
                this.dataForm.pageIndex = page;
                // this.getInvoiceList();
            },
            // 分页显示数量改变事件
            handleSizeChange(rows) {
                this.dataForm.pageIndex = 1;
                this.dataForm.pageSize = rows;
                // this.getInvoiceList();
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .deleteModule{
        padding: 20px;
    }
    .noDeleteBtn{
        padding-bottom: 0px;
        .titleBox{
            width: 75%;
        }
    }
    .titleBox{
        width: 50%;
        display: flex;
        color: #101010;
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        font-weight: 600;
        border-bottom: 1px solid #bbbbbb;
        padding-bottom: 10px;
        margin-bottom: 20px;
    }
</style>
